var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dialer-settings-main"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-3 calc-title-widthIOS v2"
  }, [_c('div', {
    staticClass: "settingsTextAndIconOnTop",
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "backToSettingsList-IOSIcon",
      "width": "11.434",
      "height": "20"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }), _c('div', {
    staticClass: "settingsTextOnTop"
  }, [_vm._v("Settings")])], 1), _c('div', {
    staticClass: "dialer-settings-title topMainHeading"
  }, [_vm._v("IVR")]), _c('div', {
    staticClass: "plus-IOSIcon-container",
    on: {
      "click": function ($event) {
        _vm.api.add_ivr.send ? '' : _vm.$modal.show('AddIVR', {
          suggested_name: `IVR MENU ${Object.values(_vm.getVoipIVRS).length + 1}`
        });
      }
    }
  }, [_c('vb-icon', {
    staticClass: "plus-IOSIcon",
    attrs: {
      "icon": "plus-IOSIcon",
      "width": "20",
      "height": "19.992"
    }
  })], 1)]), _c('section', {
    staticClass: "dialer-settings-section dialer-ivr-setting"
  }, [_c('div', {
    staticClass: "mobileInputIOS iconOnLeft mt-32px"
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search numbers"
    },
    model: {
      value: _vm.filter.ivrs.search,
      callback: function ($$v) {
        _vm.$set(_vm.filter.ivrs, "search", $$v);
      },
      expression: "filter.ivrs.search"
    }
  }), _c('vb-icon', {
    staticClass: "mobileInputIOS-icon",
    attrs: {
      "width": "13.785",
      "height": "13.726",
      "icon": "Search-IOSIcon"
    }
  })], 1), _c('div', {
    staticClass: "basicWhiteIOScard mt-32px mb-16px"
  }, _vm._l(_vm.filterIVR, function (menu) {
    return _c('div', {
      key: menu.voipaccount,
      staticClass: "basicWhiteIOScard-item",
      on: {
        "click": function ($event) {
          return _vm.$modal.show('EditIVR', {
            accountcode: menu.voipaccount
          });
        }
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "InfoComponentInsideAnroidIOSApp"
    }, [_c('vb-avatar', {
      attrs: {
        "id": menu.voipaccount
      }
    })], 1), _c('div', {
      staticClass: "d-flex flex-column"
    }, [[_c('div', {
      staticClass: "headingInsideTable"
    }, [_vm._v(" " + _vm._s(menu.label || '') + " ")])]], 2)]), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('vb-audio-player', {
      staticClass: "IosAudioPlayer mr-8px",
      attrs: {
        "src": _vm._f("welcomgreetingsrc")(menu)
      }
    }), _c('vb-icon', {
      staticClass: "rightFacingArrow",
      attrs: {
        "icon": "rightFacingArrow-IOSIcon",
        "width": "16.642",
        "height": "15.275"
      }
    })], 1)]);
  }), 0), _c('EditIVRModal', {
    on: {
      "update-list": function ($event) {
        return _vm.afterAdding();
      }
    }
  }), _c('AddIVRModal', {
    on: {
      "added": function ($event) {
        return _vm.afterAdding();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }